import { Command } from 'cmdk';
import styled from 'styled-components';
import { body1Medium, colors, spacing } from 'ui/theme';

export const CommandInput = styled(Command.Input)`
  ${body1Medium}
  border: none;
  width: 100%;
  outline: none;
  padding: 0;
  background: ${colors.backgroundPrimary};
  border-radius: 0;
  box-shadow: none;

  &::placeholder {
    color: ${colors.textDisabled};
  }
`;

export const PageNameBadge = styled.div`
  ${body1Medium}
  color: ${colors.textSecondary};
  padding: ${spacing.eighth} ${spacing.half};
  background-color: ${colors.backgroundSecondary};
  border: 1px solid ${colors.borderPrimarySubtle};
  border-radius: ${spacing.quarter};
  flex: none;
`;

export const SearchBar = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacing.threeQuarter};
  align-items: center;
  padding: ${spacing.half} ${spacing.base};
  border-bottom: ${spacing.single} solid ${colors.borderPrimarySubtle};
`;

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacing.half};
  height: ${spacing.doubleHalf};
  align-items: center;
  width: 100%;
`;
